import { SharedDocumalisModule } from '@documalis/shared-documalis.module';
import { NgModule } from '@angular/core';
import { UserRoutes } from './user.routes';
import { ListUsersComponent } from './list-users/list-users.component';
import { FormUserComponent } from './_components/form-user/form-user.component';
import { AddUserComponent } from './add-user/add-user.component';
import { EditUserComponent } from './edit-user/edit-user.component';
import { TranslateModule } from '@ngx-translate/core';
import { InputSwitchModule } from 'primeng/inputswitch';
import { PasswordModule } from 'primeng/password';
import { FieldsetModule } from 'primeng/fieldset';
import { RadioButtonModule } from 'primeng/radiobutton';

@NgModule({
    imports: [UserRoutes, SharedDocumalisModule, TranslateModule, InputSwitchModule, PasswordModule, FieldsetModule, RadioButtonModule],
    declarations: [ListUsersComponent, AddUserComponent, EditUserComponent, FormUserComponent],
})
export class UserModule {}
